var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "d-flex flex-row align-items-center",
      class: _vm.clientLogin
        ? "material-layout--label-client"
        : "material-layout--label",
      style: _vm.hiddenLabel ? "display: none !important" : "",
      attrs: { for: _vm.inputId },
    },
    [
      _vm.$slots["default"]
        ? _vm._t("default")
        : [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }